const GITHUB_REPOSITORY_FULL_NAME =
  /^[A-Za-z0-9](?:[A-Za-z0-9]|-(?=[A-Za-z0-9])){0,38}\/[A-Za-z0-9._-]{1,100}$/;
const FORBIDDEN_GIT_REF_CHARACTERS = new Set([
  '~',
  '^',
  ':',
  '?',
  '*',
  '[',
  '\\',
]);

export const validateWorkflowRepositoryFullName = (
  value: string,
): string | null => {
  if (!value) {
    return null;
  }

  const repositoryName = value.split('/')[1];
  if (
    value.length > 140 ||
    !GITHUB_REPOSITORY_FULL_NAME.test(value) ||
    repositoryName === '.' ||
    repositoryName === '..'
  ) {
    return 'Repository must use the canonical owner/name format (for example, Capitol-Operator/workflows).';
  }

  return null;
};

export const validateWorkflowBranch = (value: string): string | null => {
  if (!value) {
    return null;
  }

  if (
    value.length > 255 ||
    value === '@' ||
    value.startsWith('/') ||
    value.startsWith('.') ||
    value.startsWith('-') ||
    value.endsWith('/') ||
    value.endsWith('.') ||
    value.includes('..') ||
    value.includes('@{') ||
    value.includes('//') ||
    [...value].some((character) =>
      FORBIDDEN_GIT_REF_CHARACTERS.has(character),
    ) ||
    [...value].some((character) => {
      const codePoint = character.codePointAt(0) ?? 0;
      return /\s/.test(character) || codePoint < 32 || codePoint === 127;
    })
  ) {
    return 'Branch must be a safe Git branch/ref name without spaces or reserved characters.';
  }

  const hasInvalidComponent = value
    .split('/')
    .some(
      (component) =>
        !component ||
        component.startsWith('.') ||
        component.endsWith('.') ||
        component.endsWith('.lock'),
    );

  return hasInvalidComponent
    ? 'Branch must be a safe Git branch/ref name without hidden or .lock path components.'
    : null;
};
